<template>
  <div class="content">
    <div class="box">
      <div class="english-name">
        <div
          v-for="item in list"
          :key="item.key"
          class="sbox tab"
          @mouseenter="changeTag(item.key)"
          @click="changeTag(item.key)"
          :style="
            item.key === target &&
            'border-bottom: 2px solid rgba(203, 180, 134, 1); color: #000; '
          "
        >
          {{ item.name }}
        </div>
      </div>
      <div class="swiper-content" v-show="target !== 'lxfs'">
        <a-carousel :dots="false" ref="swiper" :autoplay="false">
          <div
            class="swiper-box"
            v-for="(item, index) in iconList"
            :key="index"
          >
            <div
              class="swiper-desc ffcs-img"
              v-for="citem in item"
              :key="citem.fileHttpUrl"
            >
              <img class="icon-img" :src="citem.fileHttpUrl" />
            </div>
          </div>
        </a-carousel>
        <div class="arrow">
          <p @click="choose(true)">
            <img src="../../../assets/images/icon_carousel_left.png" />
          </p>
          <p @click="choose(false)">
            <img src="../../../assets/images/icon_carousel_right.png" />
          </p>
        </div>
      </div>
      <div
        class="design-html"
        v-show="target === 'lxfs'"
        v-html="val"
        style="
          font-size: 18px;
          font-family: Microsoft YaHei;
          color: #3a3a3a;
          text-align: left;
        "
      ></div>
    </div>
    <!-- <div class="content_s" v-show="target === 'lxfs'"></div> -->
  </div>
</template>

<script>
const list = [
  { name: "服务客户", key: "cjwt" },
  { name: "了解我们", key: "lxfs" },
];

import { getPic, getStep, getDetail } from "@/api/foreignCompanyService";
import { getFileDetails } from "@/api/file";
export default {
  name: "client",
  data() {
    return {
      list,
      iconList: [],
      target: "cjwt",
      val: "",
      isShow: false,
    };
  },
  created() {
    this.changeTag("cjwt");
  },
  methods: {
    choose(isprev) {
      if (isprev) {
        this.$refs && this.$refs.swiper.prev();
      } else {
        this.$refs && this.$refs.swiper.next();
      }
    },
    changeTag(val) {
      this.isShow = true;
      this.target = val;
      const mapObj = {
        qzxx: "RES3AB1EB4E66BBD25",
        cjwt: "RES4FC5BF32B989502",
      };
      if (mapObj[val]) {
        getPic(mapObj[val], "", 999).then(async (res) => {
          this.iconList = JSON.parse(JSON.stringify([]));
          const list = JSON.parse(JSON.stringify([]));
          const data = this._.get(res, "data.records", []);
          for (let i of data) {
            const pic = await getDetail(i.picCode);
            const img = await getFileDetails(
              this._.get(pic, "data.appCode"),
              this._.get(pic, "data.tenantCode"),
              [this._.get(pic, "data.contentPicFileDtoList.0.fileCode")]
            );
            list.push(...Object.values(this._.get(img, "data")));
          }
          this.iconList = Object.values(list).reduce(
            (acc = [], item, index) => {
              if (index === 0) {
                acc[0] = [item];
              } else if ((index + 1) % 7 === 0) {
                acc.push([item]);
              } else {
                acc[acc.length - 1].push(item);
              }
              return acc;
            },
            []
          );
          this.choose(true);
        });
      } else {
        getStep("RES9073F768BFCE5CF").then((res) => {
          this.val = this._.get(res, "data.contentHtml", "");
        });
      }
    },
  },
};
</script>

<style scoped lang='less'>
p {
  margin: 0;
  padding: 0;
}

/* .content_s {
  height: 302.25px;
} */
.content {
  width: 100%;
  position: relative;
  top: 0;
  margin-top: 20px;
  padding-bottom: 30px;
}
.box {
  width: 1140px;
  /* height: 550px; */
  position: relative;
  margin: auto;
  // left: 50%;
  // transform: translateX(-50%);
  background: rgba(255, 255, 255, 1);
}
.chinese-name {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  position: absolute;
  left: 50%;
  top: 40px;
  transform: translateX(-50%);
  z-index: 999;
}
.english-name {
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #faf5f5;
  position: relative;
  margin: 50px 0;
  > div {
    display: inline-block;
    width: 112px;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 54px;
    cursor: pointer;
  }
  > div:not(:last-of-type) {
    margin-right: 80px;
  }
}
.swiper-content {
  height: 360px;
  width: 1140px;
  position: relative;
  .swiper-box {
    text-align: center;
    font-size: 0px;
    text-align: left;
    .swiper-desc {
      display: inline-block;
      width: 360px;
      height: 170px;
      background: #ffffff;
      border: 1px solid #e5e5e5;
      box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.04);
      text-align: center;
      margin-right: 29px;
      > img {
        display: inline-block;
        width: 240px;
        height: 113px;
        margin-top: 28.5px;
      }
      > p {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3a3a3a;
        margin-top: 14px;
      }
      > span {
        font-size: 10px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3a3a3a;
        opacity: 0.68;
        margin-top: 10px;
      }
    }
  }
  .swiper-desc:nth-of-type(-n + 3) {
    margin-bottom: 27px;
  }
  .swiper-desc:nth-of-type(3n) {
    margin-right: 0px;
  }
}
.arrow {
  cursor: pointer;
  p {
    position: absolute;
    width: 20px;
    height: 34px;
    top: 163px;
    img {
      width: 20px;
      height: 34px;
    }
  }
  p:first-of-type {
    left: -40px;
  }
  p:last-of-type {
    right: -36px;
  }
}
.content-box {
  width: 500px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  text-align: left;
  .sbox {
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    margin-right: 45px;
  }
  .tab {
    width: 80px;
    padding-bottom: 40px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(188, 190, 192, 1);
    cursor: pointer;
  }
}
/deep/p.ql-align-center {
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/foreignCompanyService/siderContent-04.vue